import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

const LocationDistance = ({ label, accountId }) => {
	const labels = useLabels();

	const buttonProps = {
		'data-href': `/fragments/location-distance.htm?selectedAccountId=${accountId}`,
		'data-title': labels.get('VEHICLE_LOCATION'),
		'data-width': '800',
		'data-dialog-class': 'sms-form-dialog',
		'data-cache': false
	};
	const buttonClasses = ['btn-unstyled', 'text-muted', 'dialog'];

	// Label comes in formatted as 'accountName ::: geoDist' from the `locationDistance` item in the `attributes` array
	// This splits it and applies an underline only on the geoDist if present
	const [accountName, geoDist] = label.split(':::');

	return (
		<button
			{...buttonProps}
			type="button"
			className={setClassNames([
				...buttonClasses,
				!geoDist && 'text-decoration-underline'
			])}
		>
			{accountName}
			{geoDist && (
				<span className="text-decoration-underline">{geoDist}</span>
			)}
		</button>
	);
};

LocationDistance.propTypes = {
	label: PropTypes.string.isRequired,
	accountId: PropTypes.string.isRequired
};

export default LocationDistance;
